import { render } from "./ListOfFeaturedAmenities.vue?vue&type=template&id=5a609aba&scoped=true"
import script from "./ListOfFeaturedAmenities.vue?vue&type=script&lang=js"
export * from "./ListOfFeaturedAmenities.vue?vue&type=script&lang=js"

import "./ListOfFeaturedAmenities.vue?vue&type=style&index=0&id=5a609aba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a609aba"]])

export default __exports__